module.exports = __webpack_public_path__ + "static/img/作品展示2.4d902fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/作品展示2.jpg
// module id = cIXp
// module chunks = 2